import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryPageDescriptionFieldModule } from '../summary-page-description-field/summary-page-description-field.module';
import { SummaryPagePropertyDescriptionSectionComponent } from './summary-page-property-description-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgRackModule,
        SummaryPageDescriptionFieldModule
    ],
    declarations: [SummaryPagePropertyDescriptionSectionComponent],
    exports: [SummaryPagePropertyDescriptionSectionComponent]
})
export class SummaryPagePropertyDescriptionSectionModule {}
